import React from 'react';
import { Box, Skeleton, Typography } from '@mui/material';
import { HighChartDonutChart } from '../../../shared';
import { useSelector } from 'react-redux';
import { AGE_ENGAGEMENT_CHART_OPTIONS } from './contants';

const GenderEngagement=() =>{
    const { dtcData } = useSelector((state) => state.webMatrix);
    const { isWebMatrixPatientLoading, genderEngagementData } = dtcData;
    return (
        <Box className="container-p-24-br-16 bg-gray-50">
            <Box>
                <Typography className="text-md-medium gray-900">
                Engagement Breakdown By Gender
                </Typography>
            </Box>
            {/* HighChartDonutChart */}
            {
                isWebMatrixPatientLoading ? <Skeleton height={400} variant="rectangular" width='100%' /> :
                    <HighChartDonutChart
                        chartOptions={AGE_ENGAGEMENT_CHART_OPTIONS}
                        seriesData={genderEngagementData}
                    />
            }
        </Box>
    );
};

export default GenderEngagement;
